import { useEffect, useState } from "react";

const useTranscription = () => {
  // Change transcription to be an array of strings
  const [transcription, setTranscription] = useState<string[]>([]);
  const [interimTranscription, setInterimTranscription] = useState("");

  const handleCopyToClipboard = () => {
    const textToCopy = transcription.join(" ");
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        alert("Transcription copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  const handleClearText = () => {
    console.log("Clearing text");
    setTranscription([]);
  };

  const handleTranscription = (data: {
    final: boolean;
    transcript: string;
  }) => {
    if (data && typeof data === "object" && data.hasOwnProperty("final")) {
      if (data.final) {
        // Add new final transcript as a new element in the transcription array
        setTranscription((prev) => [...prev, data.transcript]);
        setInterimTranscription("");
      } else {
        setInterimTranscription(data.transcript);
      }
    }
  };

  return {
    transcription,
    interimTranscription,
    handleCopyToClipboard,
    handleClearText,
    handleTranscription,
  };
};

export default useTranscription;
